import React from 'react';

interface Props {
  size?: number;
  className?: string;
}

/**
 * Ruby Till brand mark — gem inside camera-bracket viewfinder, crimson on
 * transparent. Geometry mirrors the master SVG in
 * branding/rubytill-gem-LOGO/svg/ruby-till.svg, scaled to a 200x200 viewBox
 * for crisp rendering at any size. Same component as platform-app's
 * pages/rubytill-landing/components/RubyLogo.tsx — kept in sync by hand
 * since super-admin-ui is a separate Vite app.
 */
export const RubyLogo: React.FC<Props> = ({ size = 28, className }) => {
  const cx = 100, cy = 100;
  const s = 1.4;
  const gemCy = cy - 12.5 * s;
  const pts = {
    T_TL: [cx - 12 * s, gemCy - 20 * s], T_TR: [cx + 12 * s, gemCy - 20 * s], T_R: [cx + 18 * s, gemCy - 12 * s],
    T_BR: [cx + 12 * s, gemCy - 4 * s], T_BL: [cx - 12 * s, gemCy - 4 * s], T_L: [cx - 18 * s, gemCy - 12 * s],
    G_TL: [cx - 22 * s, gemCy - 20 * s], G_TR: [cx + 22 * s, gemCy - 20 * s], G_R: [cx + 38 * s, gemCy],
    G_BR: [cx + 18 * s, gemCy + 12 * s], G_BL: [cx - 18 * s, gemCy + 12 * s], G_L: [cx - 38 * s, gemCy],
    P: [cx, gemCy + 45 * s],
  };
  const arr = [pts.T_TL, pts.T_TR, pts.T_R, pts.T_BR, pts.T_BL, pts.T_L,
    pts.G_TL, pts.G_TR, pts.G_R, pts.G_BR, pts.G_BL, pts.G_L, pts.P];
  const lines: [number, number][] = [
    [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0],
    [0, 6], [1, 7], [2, 8], [3, 9], [4, 10], [5, 11],
    [6, 7], [7, 8], [8, 9], [9, 10], [10, 11], [11, 6],
    [8, 12], [9, 12], [10, 12], [11, 12],
  ];
  const xL = 19, xR = 181, yT = 19, yB = 181, arm = 22;

  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" className={className}>
      <g stroke="#DC143C" strokeWidth={6} fill="none" strokeLinecap="round" strokeLinejoin="miter">
        <polyline points={`${xL},${yT + arm} ${xL},${yT} ${xL + arm},${yT}`} />
        <polyline points={`${xR - arm},${yT} ${xR},${yT} ${xR},${yT + arm}`} />
        <polyline points={`${xL},${yB - arm} ${xL},${yB} ${xL + arm},${yB}`} />
        <polyline points={`${xR - arm},${yB} ${xR},${yB} ${xR},${yB - arm}`} />
      </g>
      <g stroke="#DC143C" strokeWidth={4.3} fill="none" strokeLinejoin="miter" strokeLinecap="round">
        {lines.map(([a, b], i) => (
          <line key={i} x1={arr[a][0]} y1={arr[a][1]} x2={arr[b][0]} y2={arr[b][1]} />
        ))}
      </g>
      {arr.map((n, i) => (
        <circle key={i} cx={n[0]} cy={n[1]} r={3.5} fill="#DC143C" />
      ))}
    </svg>
  );
};
